import { drivewayForm, ROAD_ORGAN } from "modules/ebiForms/definitions/sharedRoads";
import { EEbiFormOffice } from "modules/ebiForms/typings";

/**
 * E9. Wniosek o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi powiatowej — art. 29 ust. 1, 3, 3a i 4
 * ustawy o drogach publicznych; opłata 82 zł (część III ust. 44 pkt 2 załącznika do ustawy o opłacie skarbowej), zjazd do
 * budynku mieszkalnego zwolniony. Brak wzoru ogólnopolskiego; układ jak wzór PZD Tarnów
 * (https://pzdtarnow.pl/wp-content/uploads/2024/12/WNIOSEK-Wydanie-zgody-na-lokalizacje-przebudowe-zjazdu.pdf — pobrany
 * 2026-10-22: tak): lokalizacja / przebudowa, numer drogi powiatowej, działki, miejscowość i gmina, cele wykorzystania
 * nieruchomości i ich zmiana, oświadczenie o tytule prawnym; załączniki: mapa 1:500/1:1000, tytuł prawny, dowód opłaty
 * za zjazd do obiektów innych niż mieszkaniowe. Wspólny builder z B6 i D2: definitions/sharedRoads.ts.
 */
const E9 = drivewayForm({
  code: "E9",
  title: "Wniosek o wydanie zezwolenia na lokalizację lub przebudowę zjazdu z drogi powiatowej",
  description: "Zezwolenie zarządcy drogi powiatowej na budowę nowego albo przebudowę istniejącego zjazdu (wjazdu) do nieruchomości.",
  organ: ROAD_ORGAN.countyUnit,
  office: EEbiFormOffice.CountyUnit,
  road: "powiatowa",
});

export default E9;
